module.exports = __webpack_public_path__ + "static/img/qinghong.b730f4a6.png";